import { Box, Grid, Typography, useTheme } from "@mui/material";
import PropTypes from "prop-types";

const ViewOnly = ({ label, value, xs = 3 }) => {
  const theme = useTheme();
  return (
    <Grid item xs={xs}>
      <Typography
        sx={{
          fontSize: 12,
          color: theme.palette.grey["A300"],
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{ fontSize: 14, marginTop: 2, color: theme.palette.grey["A300"] }}
      >
        {value}
      </Typography>
    </Grid>
  );
};

const TooltipView = ({ data = {} }) => {
  const theme = useTheme();
  const {
    totalDoReleasedQuantity,
    pendingDoQuantity,
    dispatchQuantity,
    totalOrderedQuantity,
    measurementUnit,
  } = data;
  return (
    <Box
      sx={{
        width: 400,
        padding: 2,
        backgroundColor: theme.palette.common.white,
      }}
    >
      <Grid container spacing={1}>
        <ViewOnly
          label="DO released quantity"
          value={`${totalDoReleasedQuantity} ${measurementUnit}`}
        />
        <ViewOnly
          label="Pending quantity"
          value={`${pendingDoQuantity} ${measurementUnit}`}
        />
        <ViewOnly
          label="Dispatched quantity"
          value={`${dispatchQuantity} ${measurementUnit}`}
        />
        <ViewOnly
          label="Total Ordered Quantity"
          value={`${totalOrderedQuantity} ${measurementUnit}`}
        />
      </Grid>
    </Box>
  );
};

TooltipView.propTypes = {
  data: PropTypes.object,
};

export default TooltipView;
